import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetInventoryUsage(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetInventoryUsageAttempt', function* () {
        yield* handleGetInventoryUsage(api);
    });
}

function* handleGetInventoryUsage(api: GoldGateway ) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const branchName = reduxState.gold.goldInventoryReport.branchInventory.filters.branchName;
    const branchesList = reduxState.branch.allBranches;
    const branchId = branchesList.find((branch) => branch.branchName === branchName)?.branchId;

    const response = yield* call([api, api.getInventoryUsage], {
        authToken,
        branchId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetInventoryUsageFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetInventoryUsageSuccess(response.data));
    }
}
